export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13163.6dd340c2.jpg";